import React, { useRef } from 'react';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';

function FileDropZone({ onFilesSelected, accept = 'image/*', maxFiles = 5, multiple = true }) {
  const inputRef = useRef(null);
  const esImagen = accept && accept.includes('image');
  const esNativo = Capacitor.isNativePlatform();

  const handleFileInput = (e) => {
    const files = Array.from(e.target.files);
    const selectedFiles = multiple ? files.slice(0, maxFiles) : files.slice(0, 1);
    if (selectedFiles.length > 0) onFilesSelected(selectedFiles);
    e.target.value = '';
  };

  const abrirGaleriaNativa = async () => {
    try {
      if (multiple) {
        const result = await Camera.pickImages({
          quality: 85,
          limit: maxFiles,
        });
        const files = await Promise.all(
          result.photos.map(async (photo) => {
            const resp = await fetch(photo.webPath);
            const blob = await resp.blob();
            return new File([blob], `foto_${Date.now()}.jpg`, { type: 'image/jpeg' });
          })
        );
        onFilesSelected(files);
      } else {
        const photo = await Camera.getPhoto({
          quality: 85,
          allowEditing: false,
          resultType: CameraResultType.Uri,
          source: CameraSource.Photos,
        });
        const resp = await fetch(photo.webPath);
        const blob = await resp.blob();
        const file = new File([blob], `foto_${Date.now()}.jpg`, { type: 'image/jpeg' });
        onFilesSelected([file]);
      }
    } catch (e) {
      // usuario canceló
    }
  };

  const btnStyle = {
    width: '100%',
    padding: '13px 16px',
    border: '2px dashed var(--primary)',
    borderRadius: 'var(--radius-button)',
    background: 'var(--bg-primary, #f0f4ff)',
    color: 'var(--primary)',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    textAlign: 'center',
  };

  return (
    <div>
      {!esNativo && (
        <input ref={inputRef} type="file" accept={accept} multiple={multiple} onChange={handleFileInput} style={{ display: 'none' }} />
      )}
      <button
        type="button"
        onClick={esNativo && esImagen ? abrirGaleriaNativa : () => inputRef.current?.click()}
        style={btnStyle}
      >
        🖼️ Seleccionar imagen{multiple ? ` (máximo ${maxFiles})` : ''}
      </button>
    </div>
  );
}

export default FileDropZone;
